/**
 * Product Reviews Module
 * Handles review form popup, reviews list, and form submission
 */

(function() {
  'use strict';

  // Check if reviews section exists on page
  const section = document.querySelector('.reviews-section');
  if (!section) return;

  // Get product data
  const productHandle = section.dataset.productHandle;
  const productTitle = section.dataset.productTitle;
  const starEmptyUrl = section.dataset.starEmpty || '/assets/icon_star1.svg';
  const starFilledUrl = section.dataset.starFilled || '/assets/icon_star2.svg';

  // Elements
  const openReviewFormBtn = document.getElementById('open-review-form-btn');
  const reviewFormPopup = document.getElementById('review-form-popup');
  const closeReviewFormBtn = document.getElementById('close-review-form-btn');
  const reviewForm = document.getElementById('review-form');
  const reviewSuccessPopup = document.getElementById('review-success-popup');
  const closeSuccessPopupBtn = document.getElementById('close-success-popup-btn');
  const reviewsListContainer = document.getElementById('reviews-list-container');
  const reviewsLoading = document.getElementById('reviews-loading');
  const reviewsEmptyState = document.getElementById('reviews-empty-state');
  const reviewsError = document.getElementById('reviews-error');
  const reviewsCount = document.getElementById('reviews-count');
  const reviewsSectionHeader = document.querySelector('.reviews-section__header');
  const openReviewFormEmptyBtn = document.getElementById('open-review-form-empty-btn');
  const photoPreviewContainer = document.getElementById('photo-preview-container');
  const photoInput = document.getElementById('review-photos');
  const productRatingStars = document.getElementById('product-rating-stars');
  const serviceRatingStars = document.getElementById('service-rating-stars');
  const productRatingValue = document.getElementById('product-rating-value');
  const serviceRatingValue = document.getElementById('service-rating-value');
  const combinedRatingInput = document.getElementById('combined-rating');
  const reviewFormError = document.getElementById('review-form-error');
  const submitReviewBtn = document.getElementById('submit-review-btn');
  
  // Photo viewer elements
  const photoViewer = document.getElementById('reviews-photo-viewer');
  const closePhotoViewerBtn = document.getElementById('close-photo-viewer-btn');
  const photoViewerImage = document.getElementById('photo-viewer-image');
  const photoViewerPrevBtn = document.getElementById('photo-viewer-prev-btn');
  const photoViewerNextBtn = document.getElementById('photo-viewer-next-btn');
  const photoViewerCurrent = document.getElementById('photo-viewer-current');
  const photoViewerTotal = document.getElementById('photo-viewer-total');

  // State
  let scrollPosition = 0;
  let productRating = 0;
  let serviceRating = 0;
  let uploadedPhotos = [];
  
  // Photo viewer state
  let allPhotos = [];
  let currentPhotoIndex = 0;

  // Utility functions
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  function renderStars(rating) {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    let starsHtml = '';
    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        starsHtml += `<img src="${starFilledUrl}" alt="Star" width="19" height="18" style="display: inline-block;">`;
      } else if (i === fullStars + 1 && hasHalfStar) {
        starsHtml += `<img src="${starFilledUrl}" alt="Star" width="19" height="18" style="display: inline-block; opacity: 0.5;">`;
      } else {
        starsHtml += `<img src="${starEmptyUrl}" alt="Star" width="19" height="18" style="display: inline-block;">`;
      }
    }
    return starsHtml;
  }

  function calculateRating(productRating, serviceRating) {
    // Если есть оба рейтинга - вычисляем среднее арифметическое и округляем до целого
    if (productRating > 0 && serviceRating > 0) {
      return Math.min(Math.max(Math.round((productRating + serviceRating) / 2), 1), 5);
    }
    // Если есть только один рейтинг - используем его
    if (productRating > 0) {
      return Math.min(Math.max(productRating, 1), 5);
    }
    if (serviceRating > 0) {
      return Math.min(Math.max(serviceRating, 1), 5);
    }
    // Если нет рейтингов - возвращаем 0
    return 0;
  }

  function lockScroll() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.add('popup-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.classList.remove('popup-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    if (scrollPosition !== undefined) {
      window.scrollTo(0, scrollPosition);
      scrollPosition = 0;
    }
  }

  // Popup management
  function openReviewForm() {
    if (!reviewFormPopup) return;
    lockScroll();
    reviewFormPopup.style.display = 'flex';
    setTimeout(() => {
      reviewFormPopup.classList.add('reviews-popup--open');
    }, 10);
    const firstInput = reviewFormPopup.querySelector('input[type="text"]');
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100);
    }
  }

  function closeReviewForm() {
    if (!reviewFormPopup) return;
    reviewFormPopup.classList.remove('reviews-popup--open');
    setTimeout(() => {
      reviewFormPopup.style.display = 'none';
      unlockScroll();
    }, 300);
    resetForm();
  }

  function openSuccessPopup() {
    if (!reviewSuccessPopup) return;
    lockScroll();
    reviewSuccessPopup.style.display = 'flex';
    setTimeout(() => {
      reviewSuccessPopup.classList.add('reviews-popup--open');
    }, 10);
  }

  function closeSuccessPopup() {
    if (!reviewSuccessPopup) return;
    reviewSuccessPopup.classList.remove('reviews-popup--open');
    setTimeout(() => {
      reviewSuccessPopup.style.display = 'none';
      unlockScroll();
    }, 300);
  }

  function resetForm() {
    if (reviewForm) {
      reviewForm.reset();
    }
    productRating = 0;
    serviceRating = 0;
    uploadedPhotos = [];
    updateStarDisplay(productRatingStars, 0);
    updateStarDisplay(serviceRatingStars, 0);
    productRatingValue.value = '';
    serviceRatingValue.value = '';
    combinedRatingInput.value = '';
    photoPreviewContainer.innerHTML = '';
    updatePhotoInput();
    hideFormError();
  }

  // Star rating logic
  function updateStarDisplay(container, rating) {
    if (!container) return;
    const stars = container.querySelectorAll('.reviews-popup__star');
    stars.forEach((star, index) => {
      const value = index + 1;
      const emptyIcon = star.querySelector('.reviews-popup__star-icon--empty');
      const filledIcon = star.querySelector('.reviews-popup__star-icon--filled');
      if (!emptyIcon || !filledIcon) return;
      if (value <= rating) {
        emptyIcon.style.display = 'none';
        filledIcon.style.display = 'block';
      } else {
        emptyIcon.style.display = 'block';
        filledIcon.style.display = 'none';
      }
    });
  }

  function setupStarRating(container, type) {
    if (!container) return;
    const stars = container.querySelectorAll('.reviews-popup__star');
    
    stars.forEach((star, index) => {
      const value = index + 1;
      star.addEventListener('click', () => {
        if (type === 'product') {
          productRating = value;
          productRatingValue.value = value;
        } else {
          serviceRating = value;
          serviceRatingValue.value = value;
        }
        updateStarDisplay(container, value);
        updateCombinedRating();
      });
      star.addEventListener('mouseenter', () => {
        updateStarDisplay(container, value);
      });
      star.addEventListener('mouseleave', () => {
        const currentRating = type === 'product' ? productRating : serviceRating;
        updateStarDisplay(container, currentRating);
      });
      star.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          star.click();
        }
      });
    });
  }

  function updateCombinedRating() {
    if (productRating > 0 || serviceRating > 0) {
      const combined = calculateRating(productRating, serviceRating);
      combinedRatingInput.value = combined;
    }
  }

  // Photo upload
  function setupPhotoUpload() {
    if (!photoInput) return;
    photoInput.addEventListener('change', (e) => {
      const files = Array.from(e.target.files);
      handlePhotoFiles(files);
    });
  }

  function handlePhotoFiles(files) {
    const maxSize = 5 * 1024 * 1024; // 5MB
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const validFiles = [];
    const errors = [];

    files.forEach((file, index) => {
      if (!allowedTypes.includes(file.type)) {
        errors.push(`File "${file.name}" is not a valid image type`);
        return; // Пропускаем этот файл
      }
      if (file.size > maxSize) {
        errors.push(`Photo "${file.name}" exceeds maximum size (5MB)`);
        return; // Пропускаем этот файл
      }
      validFiles.push(file);
    });

    // Показываем ошибки если есть
    if (errors.length > 0) {
      showFormError(errors.join(', '));
    }

    // Проверяем общее количество фотографий
    const totalPhotos = uploadedPhotos.length + validFiles.length;
    if (totalPhotos > 5) {
      showFormError('Maximum 5 photos allowed');
      uploadedPhotos = [...uploadedPhotos, ...validFiles].slice(0, 5);
    } else {
      uploadedPhotos = [...uploadedPhotos, ...validFiles];
    }
    
    renderPhotoPreviews();
    updatePhotoInput();
  }

  function updatePhotoInput() {
    if (!photoInput) return;
    const dt = new DataTransfer();
    uploadedPhotos.forEach(file => {
      dt.items.add(file);
    });
    photoInput.files = dt.files;
  }

  function renderPhotoPreviews() {
    if (!photoPreviewContainer) return;
    photoPreviewContainer.innerHTML = '';
    uploadedPhotos.forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const preview = document.createElement('div');
        preview.className = 'reviews-popup__photo-preview-item';
        preview.innerHTML = `
          <img src="${e.target.result}" alt="Preview ${index + 1}" loading="lazy">
          <button type="button" class="reviews-popup__photo-remove" data-index="${index}" aria-label="Remove photo">
            <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M12 12L2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
        `;
        const removeBtn = preview.querySelector('.reviews-popup__photo-remove');
        removeBtn.addEventListener('click', () => {
          uploadedPhotos.splice(index, 1);
          renderPhotoPreviews();
          updatePhotoInput();
        });
        photoPreviewContainer.appendChild(preview);
      };
      reader.readAsDataURL(file);
    });
  }

  // Form validation
  function validateForm() {
    const orderNumber = document.getElementById('review-order-number').value.trim();
    const text = document.getElementById('review-text').value.trim();
    const userName = document.getElementById('review-user-name').value.trim();
    const honeypot = reviewForm.querySelector('[name="honeypot"]').value;

    // Check honeypot
    if (honeypot && honeypot.trim() !== '') {
      showFormError('Spam detected');
      return false;
    }

    // Check required fields
    if (!orderNumber) {
      showFormError('Order number is required');
      return false;
    }
    if (!userName) {
      showFormError('User name is required');
      return false;
    }
    if (!text) {
      showFormError('Review text is required');
      return false;
    }

    // Check ratings
    if (!productRating || productRating === 0) {
      showFormError('Product rating is required');
      return false;
    }
    if (!serviceRating || serviceRating === 0) {
      showFormError('Service rating is required');
      return false;
    }

    // Check photos
    if (uploadedPhotos.length > 5) {
      showFormError('Maximum 5 photos');
      return false;
    }

    // Check file sizes
    const maxSize = 5 * 1024 * 1024; // 5MB
    for (let i = 0; i < uploadedPhotos.length; i++) {
      if (uploadedPhotos[i].size > maxSize) {
        showFormError(`Photo ${i + 1} exceeds maximum size (5MB)`);
        return false;
      }
    }

    return true;
  }

  function showFormError(message) {
    if (!reviewFormError) return;
    reviewFormError.textContent = message;
    reviewFormError.style.display = 'block';
  }

  function hideFormError() {
    if (!reviewFormError) return;
    reviewFormError.style.display = 'none';
    reviewFormError.textContent = '';
  }

  // Form submission
  function setupFormSubmission() {
    if (!reviewForm) return;

    reviewForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      if (!validateForm()) {
        return;
      }

      hideFormError();
      
      // Получаем значения из формы ПЕРЕД созданием FormData
      const orderNumberEl = document.getElementById('review-order-number');
      const textEl = document.getElementById('review-text');
      const userNameEl = document.getElementById('review-user-name');
      const handleEl = reviewForm.querySelector('[name="handle"]');
      const productNameEl = reviewForm.querySelector('[name="product_name"]');
      
      const orderNumber = orderNumberEl ? orderNumberEl.value.trim() : '';
      const text = textEl ? textEl.value.trim() : '';
      const userName = userNameEl ? userNameEl.value.trim() : '';
      const honeypot = reviewForm.querySelector('[name="honeypot"]')?.value || '';
      
      // Скрытые поля из формы - проверяем оба источника
      const handleFromForm = handleEl ? handleEl.value.trim() : '';
      const handle = handleFromForm || productHandle || '';
      const productNameFromForm = productNameEl ? productNameEl.value.trim() : '';
      const productName = productNameFromForm || productTitle || '';
      
      // Проверка что все обязательные поля заполнены ПЕРЕД отправкой
      if (!handle || handle.trim() === '') {
        showFormError('Product handle is missing');
        return;
      }
      if (!productName || productName.trim() === '') {
        showFormError('Product name is missing');
        return;
      }
      if (!userName || userName.trim() === '') {
        showFormError('User name is required');
        return;
      }
      if (!orderNumber || orderNumber.trim() === '') {
        showFormError('Order number is required');
        return;
      }
      if (!text || text.trim() === '') {
        showFormError('Review text is required');
        return;
      }
      
      // Проверка рейтингов - должен быть хотя бы один рейтинг
      if ((!productRating || productRating < 1 || productRating > 5) && 
          (!serviceRating || serviceRating < 1 || serviceRating > 5)) {
        showFormError('At least one rating (product or service) is required');
        return;
      }
      
      // Вычисляем финальный рейтинг для валидации
      const calculatedRating = calculateRating(productRating, serviceRating);
      if (calculatedRating < 1 || calculatedRating > 5) {
        showFormError('Rating must be between 1 and 5');
        return;
      }
      
      // Обновляем combined rating input для отображения
      updateCombinedRating();
      
      submitReviewBtn.disabled = true;
      submitReviewBtn.textContent = 'Submitting...';

      try {
        // Создаем новый FormData - FormData автоматически правильно обрабатывает UTF-8
        const formData = new FormData();
        
        // Добавляем все текстовые поля - FormData автоматически кодирует их в UTF-8
        formData.append('handle', handle.trim());
        formData.append('product_name', productName.trim());
        formData.append('user_name', userName.trim());
        formData.append('order_number', orderNumber.trim());
        formData.append('text', text.trim());
        // Отправляем рейтинги отдельно - сервер вычислит финальный рейтинг
        if (productRating > 0) {
          formData.append('product_rating', String(productRating));
        }
        if (serviceRating > 0) {
          formData.append('service_rating', String(serviceRating));
        }
        formData.append('honeypot', honeypot);
        
        // Добавляем фотографии
        uploadedPhotos.forEach((file) => {
          formData.append('photos', file);
        });
        
        // Детальное логирование FormData перед отправкой
        console.log('=== FormData before sending ===');
        console.log('FormData fields summary:', {
          handle: handle.trim(),
          product_name: productName.trim(),
          user_name: userName.trim(),
          order_number: orderNumber.trim(),
          text: text.trim().substring(0, 50) + '...',
          calculated_rating: calculatedRating,
          product_rating: productRating > 0 ? productRating : null,
          service_rating: serviceRating > 0 ? serviceRating : null,
          photos_count: uploadedPhotos.length
        });
        
        // Проверяем что все поля есть в FormData и не пустые
        console.log('FormData entries (all):');
        const formDataEntries = {};
        for (const [key, value] of formData.entries()) {
          if (typeof value === 'string') {
            formDataEntries[key] = value;
            console.log(`${key}: "${value}" (length: ${value.length})`);
          } else {
            formDataEntries[key] = `[File] ${value.name || 'unknown'}`;
            console.log(`${key}: [File] ${value.name || 'unknown'}`);
          }
        }
        
        // Проверка на пустые обязательные поля
        const requiredFields = ['handle', 'product_name', 'user_name', 'order_number', 'text'];
        const missingFields = requiredFields.filter(field => {
          const value = formDataEntries[field];
          return !value || (typeof value === 'string' && value.trim() === '');
        });
        
        if (missingFields.length > 0) {
          console.error('Missing required fields:', missingFields);
          showFormError(`Missing required fields: ${missingFields.join(', ')}`);
          submitReviewBtn.disabled = false;
          submitReviewBtn.textContent = 'Submit Review';
          return;
        }

        // Отправляем FormData - браузер автоматически установит правильный Content-Type с boundary
        // FormData автоматически правильно кодирует UTF-8 строки
        const response = await fetch('https://office.ampriomilano.com/reviews/create', {
          method: 'POST',
          body: formData,
          // НЕ устанавливаем Content-Type вручную - браузер установит его автоматически 
          // с правильным boundary и charset=utf-8 для multipart/form-data
        });
        
        console.log('Response status:', response.status, response.statusText);
        console.log('Response headers:', Object.fromEntries(response.headers.entries()));
        
        let data;
        let responseText;
        try {
          responseText = await response.text();
          console.log('Response text:', responseText);
          data = JSON.parse(responseText);
        } catch (jsonError) {
          console.error('Failed to parse response as JSON:', jsonError);
          console.error('Response text was:', responseText);
          throw new Error('Invalid response from server: ' + (responseText || 'Empty response'));
        }
        
        console.log('Parsed response data:', data);
        
        if (!response.ok) {
          // Обработка ошибок валидации от сервера
          const errorMessage = data.error || data.message || 'Error submitting review';
          const errorDetails = data.details ? (Array.isArray(data.details) ? data.details.join(', ') : data.details) : '';
          console.error('Server validation error:', {
            status: response.status,
            error: errorMessage,
            details: errorDetails,
            fullResponse: data
          });
          throw new Error(errorMessage + (errorDetails ? ': ' + errorDetails : ''));
        }
        
        // Successful submission
        if (data.ok) {
          openSuccessPopup();
          closeReviewForm();
          resetForm();
          loadReviewsList();
        } else {
          const errorMessage = data.error || data.message || 'Error submitting review';
          throw new Error(errorMessage);
        }
        
      } catch (error) {
        console.error('Error submitting form:', error);
        const errorMessage = error.message || 'An error occurred while submitting the review';
        showFormError(errorMessage);
      } finally {
        submitReviewBtn.disabled = false;
        submitReviewBtn.textContent = 'Submit Review';
      }
    });
  }

  // Load reviews list
  async function loadReviewsList() {
    if (!reviewsListContainer) return;
    
    // Show loading, hide everything else
    if (reviewsLoading) {
      reviewsLoading.classList.remove('reviews-section__loading--hidden');
    }
    if (reviewsError) reviewsError.style.display = 'none';
    if (reviewsEmptyState) {
      reviewsEmptyState.classList.remove('reviews-section__empty-state--visible');
    }
    if (reviewsSectionHeader) {
      reviewsSectionHeader.classList.add('reviews-section__header--hidden');
    }
    if (reviewsListContainer) {
      reviewsListContainer.classList.add('reviews-section__list--hidden');
    }

    try {
      const url = `https://office.ampriomilano.com/reviews/list${productHandle ? `?handle=${encodeURIComponent(productHandle)}` : ''}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error('Error loading reviews');
      }
      
      const data = await response.json();
      
      // Hide loading
      if (reviewsLoading) {
        reviewsLoading.classList.add('reviews-section__loading--hidden');
      }
      
      if (!data.reviews || data.reviews.length === 0) {
        // Show empty state, hide header and list
        if (reviewsEmptyState) {
          reviewsEmptyState.classList.add('reviews-section__empty-state--visible');
        }
        if (reviewsSectionHeader) {
          reviewsSectionHeader.classList.add('reviews-section__header--hidden');
        }
        if (reviewsListContainer) {
          reviewsListContainer.classList.add('reviews-section__list--hidden');
        }
        reviewsListContainer.innerHTML = '';
        if (reviewsCount) {
          reviewsCount.textContent = '0';
        }
        return;
      }
      
      // Hide empty state, show header and list
      if (reviewsEmptyState) {
        reviewsEmptyState.classList.remove('reviews-section__empty-state--visible');
      }
      if (reviewsSectionHeader) {
        reviewsSectionHeader.classList.remove('reviews-section__header--hidden');
      }
      if (reviewsListContainer) {
        reviewsListContainer.classList.remove('reviews-section__list--hidden');
      }
      
      renderReviewsList(data.reviews);
      
      if (reviewsCount) {
        reviewsCount.textContent = data.reviews.length;
      }
      
    } catch (error) {
      console.error('Error loading reviews:', error);
      if (reviewsLoading) {
        reviewsLoading.classList.add('reviews-section__loading--hidden');
      }
      if (reviewsError) {
        reviewsError.textContent = error.message || 'Error loading reviews';
        reviewsError.style.display = 'block';
      }
    }
  }

  function renderReviewsList(reviews) {
    if (!reviewsListContainer) return;
    const reviewsHtml = reviews.map((review, reviewIndex) => {
      const userName = escapeHtml(review.user_name || 'Anonymous');
      const userInitial = userName.charAt(0).toUpperCase();
      const date = formatDate(review.submitted_at);
      const text = escapeHtml(review.text);
      const stars = renderStars(review.rating);
      const photosHtml = review.photos && review.photos.length > 0
        ? `<div class="reviews-section__review-photos">
            ${review.photos.map((photo, photoIndex) => `
              <div class="reviews-section__review-photo" data-photo-url="${escapeHtml(photo)}">
                <img src="${escapeHtml(photo)}" alt="Review photo" loading="lazy">
              </div>
            `).join('')}
          </div>`
        : '';

      return `
        <div class="reviews-section__review-block">
          <div class="reviews-section__review-container">
            <div class="reviews-section__review-header">
              <div class="reviews-section__review-user-block">
                <div class="reviews-section__review-avatar">${userInitial}</div>
                <div class="reviews-section__review-user-info">
                  <div class="reviews-section__review-user-name">${userName}</div>
                  <div class="reviews-section__review-date">${date}</div>
                </div>
              </div>
              <div class="reviews-section__review-rating-block">
                <div class="reviews-section__review-rating-label">Customer Rating</div>
                <div class="reviews-section__review-stars">${stars}</div>
              </div>
            </div>
            <div class="reviews-section__review-message">${text}</div>
          </div>
          ${photosHtml}
          <div class="reviews-section__divider"></div>
        </div>
      `;
    }).join('');
    reviewsListContainer.innerHTML = reviewsHtml;
    
    // Setup photo click handlers after rendering
    setupPhotoViewer();
  }

  // Photo viewer functions
  function collectAllPhotos() {
    if (!reviewsListContainer) return;
    allPhotos = [];
    const photoElements = reviewsListContainer.querySelectorAll('.reviews-section__review-photo');
    photoElements.forEach((photoEl) => {
      const photoUrl = photoEl.getAttribute('data-photo-url');
      const img = photoEl.querySelector('img');
      if (photoUrl || img) {
        const url = photoUrl || (img ? (img.getAttribute('src') || img.src) : '');
        if (url) {
          allPhotos.push({
            url: url,
            element: photoEl
          });
        }
      }
    });
  }

  function openPhotoViewer(photoIndex) {
    if (!photoViewer || allPhotos.length === 0) return;
    
    currentPhotoIndex = Math.max(0, Math.min(photoIndex, allPhotos.length - 1));
    updatePhotoViewer();
    lockScroll();
    photoViewer.classList.add('reviews-photo-viewer--open');
  }

  function closePhotoViewer() {
    if (!photoViewer) return;
    photoViewer.classList.remove('reviews-photo-viewer--open');
    unlockScroll();
  }

  function updatePhotoViewer() {
    if (!photoViewerImage || allPhotos.length === 0) return;
    
    const loadingEl = document.getElementById('photo-viewer-loading');
    const currentPhoto = allPhotos[currentPhotoIndex];
    
    if (currentPhoto && photoViewerImage && currentPhoto.url) {
      // Show loading, hide image
      if (loadingEl) {
        loadingEl.classList.remove('reviews-photo-viewer__loading--hidden');
      }
      photoViewerImage.classList.remove('reviews-photo-viewer__image--loaded');
      
      // Set new image source
      photoViewerImage.setAttribute('src', currentPhoto.url);
      photoViewerImage.setAttribute('alt', `Review photo ${currentPhotoIndex + 1}`);
      
      // Handle image load
      photoViewerImage.onload = function() {
        if (loadingEl) {
          loadingEl.classList.add('reviews-photo-viewer__loading--hidden');
        }
        photoViewerImage.classList.add('reviews-photo-viewer__image--loaded');
      };
      
      // Handle image error
      photoViewerImage.onerror = function() {
        if (loadingEl) {
          loadingEl.classList.add('reviews-photo-viewer__loading--hidden');
        }
      };
    }
    
    if (photoViewerCurrent) {
      photoViewerCurrent.textContent = String(currentPhotoIndex + 1);
    }
    if (photoViewerTotal) {
      photoViewerTotal.textContent = String(allPhotos.length);
    }
    
    // Update navigation buttons
    if (photoViewerPrevBtn) {
      photoViewerPrevBtn.disabled = currentPhotoIndex === 0;
    }
    if (photoViewerNextBtn) {
      photoViewerNextBtn.disabled = currentPhotoIndex === allPhotos.length - 1;
    }
  }

  function showNextPhoto() {
    if (currentPhotoIndex < allPhotos.length - 1) {
      currentPhotoIndex++;
      updatePhotoViewer();
    }
  }

  function showPrevPhoto() {
    if (currentPhotoIndex > 0) {
      currentPhotoIndex--;
      updatePhotoViewer();
    }
  }

  function setupPhotoViewer() {
    if (!reviewsListContainer) return;
    collectAllPhotos();
    
    // Setup click handlers for photos
    const photoElements = reviewsListContainer.querySelectorAll('.reviews-section__review-photo');
    photoElements.forEach((photoEl) => {
      photoEl.addEventListener('click', () => {
        const photoIndex = allPhotos.findIndex(p => p.element === photoEl);
        if (photoIndex !== -1) {
          openPhotoViewer(photoIndex);
        }
      });
    });
  }

  // Event listeners
  function setupEventListeners() {
    if (openReviewFormBtn) {
      openReviewFormBtn.addEventListener('click', openReviewForm);
    }
    if (openReviewFormEmptyBtn) {
      openReviewFormEmptyBtn.addEventListener('click', openReviewForm);
    }
    if (closeReviewFormBtn) {
      closeReviewFormBtn.addEventListener('click', closeReviewForm);
    }
    if (closeSuccessPopupBtn) {
      closeSuccessPopupBtn.addEventListener('click', closeSuccessPopup);
    }
    if (reviewFormPopup) {
      const overlay = reviewFormPopup.querySelector('.reviews-popup__overlay');
      if (overlay) {
        overlay.addEventListener('click', closeReviewForm);
      }
    }
    if (reviewSuccessPopup) {
      const overlay = reviewSuccessPopup.querySelector('.reviews-popup__overlay');
      if (overlay) {
        overlay.addEventListener('click', closeSuccessPopup);
      }
    }
    
    // Photo viewer event listeners
    if (closePhotoViewerBtn) {
      closePhotoViewerBtn.addEventListener('click', closePhotoViewer);
    }
    if (photoViewerPrevBtn) {
      photoViewerPrevBtn.addEventListener('click', showPrevPhoto);
    }
    if (photoViewerNextBtn) {
      photoViewerNextBtn.addEventListener('click', showNextPhoto);
    }
    if (photoViewer) {
      const overlay = photoViewer.querySelector('.reviews-photo-viewer__overlay');
      if (overlay) {
        overlay.addEventListener('click', closePhotoViewer);
      }
    }
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (reviewFormPopup && reviewFormPopup.classList.contains('reviews-popup--open')) {
          closeReviewForm();
        }
        if (reviewSuccessPopup && reviewSuccessPopup.classList.contains('reviews-popup--open')) {
          closeSuccessPopup();
        }
        if (photoViewer && photoViewer.classList.contains('reviews-photo-viewer--open')) {
          closePhotoViewer();
        }
      }
      // Arrow keys for photo navigation
      if (photoViewer && photoViewer.classList.contains('reviews-photo-viewer--open')) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          showPrevPhoto();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          showNextPhoto();
        }
      }
    });
    
    // Swipe gestures for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    
    if (photoViewer) {
      photoViewer.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      photoViewer.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
    }
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next photo
          showNextPhoto();
        } else {
          // Swipe right - previous photo
          showPrevPhoto();
        }
      }
    }
  }

  // Initialize
  function init() {
    setupEventListeners();
    setupStarRating(productRatingStars, 'product');
    setupStarRating(serviceRatingStars, 'service');
    setupPhotoUpload();
    setupFormSubmission();
    loadReviewsList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

